module.exports = __webpack_public_path__ + "img/menu-hamburguer.4b8944e2.svg";